import { render } from "./ChatwallInputV2.vue?vue&type=template&id=b0f143b0"
import script from "./ChatwallInputV2.vue?vue&type=script&lang=js"
export * from "./ChatwallInputV2.vue?vue&type=script&lang=js"

import "./ChatwallInputV2.vue?vue&type=style&index=0&id=b0f143b0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__